import { DataSourceSetupComposite, enumATSModes } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox, Select } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { appcstr } from "@coreapp/utils/appcstr";
import {
  kADPEnterpriesFields,
  kADPHeaderMap,
  kADPHeaders,
  kdetailedVantageFields
} from "@coreapp/constants";

export const ADPSORS = [
  "ADP",
  "ADP Lifion",
  "Vantage",
  "ADP NG HCM",
  "WFN Next Generation",
  "ADP Enterprise",
  "ADP Canada",
  "ADP Europe",
  "ADP Detail",
  "ADP Recruitment",
  "ADP WFN CA Recruitment Module",
  "ADP Recruit Management"
];

const GetDefaultADPQuery = (adpSource, config) => {
  let query = config["query"];
  if (query == null) {
    if (["ADP", "ADP Canada", "ADP NG HCM", "WFN Next Generation"].includes(adpSource)) {
      var isActiveOnLeave = config["activeonleave"];
      if (isActiveOnLeave == null) query = "";
      else if (isActiveOnLeave) query = "ActiveOnLeave";
      else query = "<status is active>";
    } else {
      query = "workers/workerStatus/statusCode/codeValue eq 'A'";
    }
  }
  return query;
};

const BuildADPQueryOptions = (source, clickHandler) => {
  let queryOptions = [];
  switch (source) {
    case "ADP":
    case "ADP Canada":
      let activeStatus = {
        value: "<status is active>",
        label: appstr("Status is active"),
        dataKey: "query",
        clickHandler: clickHandler
      };
      let activeOnLeave = {
        value: "ActiveOnLeave",
        label: appstr("Active on leave"),
        dataKey: "query",
        clickHandler: clickHandler
      };
      queryOptions = [activeStatus, activeOnLeave];
      break;
    case "ADP Europe":
      let currentStatus = {
        value: "workers/workerStatus/statusCode/codeValue eq 'Current'",
        label: appstr("Status is current"),
        dataKey: "query",
        clickHandler: clickHandler
      };
      queryOptions = [currentStatus];
      break;
    default:
      let defaultActiveStatus = {
        value: "workers/workerStatus/statusCode/codeValue eq 'A'",
        label: appstr("Status is active"),
        dataKey: "query",
        clickHandler: clickHandler
      };
      let onLeave = {
        value: "workers/workerStatus/statusCode/codeValue eq 'L'",
        label: appstr("On leave"),
        dataKey: "query",
        clickHandler: clickHandler
      };
      queryOptions = [defaultActiveStatus, onLeave];
      break;
  }
  return queryOptions;
};

const BuildADPInputOptions = (config, inputHandler) => {
  const adpSource = config["source"];
  let inputOptions = [];
  if (Globals._wsMgr.fAdminLogin && adpSource != "ADP Europe") {
    let adpOID = {};
    adpOID.dataKey = "adpoid";
    adpOID.value = config[adpOID.dataKey];
    adpOID.label = appcstr(adpOID.dataKey);
    adpOID.placeholder = Globals._wsMgr.GetOrgInfo().fAccountName;
    inputOptions.push(adpOID);
  }

  if (adpSource === "ADP Europe") {
    let adpKeys = config["adpKeys"] ?? {};
    let adpEuropeClientID = {};
    adpEuropeClientID.onChange = inputHandler;
    adpEuropeClientID.dataKey = "clientid";
    adpEuropeClientID.value = adpKeys["clientid"] ?? "";
    adpEuropeClientID.label = appcstr("genericclientid1");
    adpEuropeClientID.placeholder = appcstr("genericclientid2");
    adpEuropeClientID.passwordMask = true;
    inputOptions.push(adpEuropeClientID);

    let adpEuropeClientSecret = {};
    adpEuropeClientSecret.onChange = inputHandler;
    adpEuropeClientSecret.dataKey = "secret";
    adpEuropeClientSecret.value = adpKeys["secret"] ?? "";
    adpEuropeClientSecret.label = appcstr("genericclientsecret1");
    adpEuropeClientSecret.placeholder = appcstr("genericclientsecret2");
    adpEuropeClientSecret.passwordMask = true;
    inputOptions.push(adpEuropeClientSecret);
  }

  if (queryAbleADPSORs.indexOf(adpSource) > -1) {
    let adpQuery = {};
    adpQuery.dataKey = "query";
    adpQuery.value = GetDefaultADPQuery(adpSource, config);
    adpQuery.label = appcstr("adpHR10");
    adpQuery.placeholder = appcstr("adpHR10a");
    adpQuery.inputProps = { type: "textarea" };
    adpQuery.optional = true;
    inputOptions.push(adpQuery);
  }
  return inputOptions;
};

const GetADPAdditionalFields = config => {
  if (config["customheaders"] == null) config["customheaders"] = [];
  var adpHeaders = kADPHeaderMap[config["source"]];
  if (adpHeaders == null) {
    adpHeaders = kADPHeaders;
  }
  if (config["doDetail"]) {
    if (config["source"] == "Vantage") {
      adpHeaders = adpHeaders.concat(kdetailedVantageFields);
    } else {
      adpHeaders = adpHeaders.concat(kADPEnterpriesFields);
    }
  }
  return adpHeaders;
};

export const queryAbleADPSORs = [
  "ADP",
  "ADP Canada",
  "Vantage",
  "ADP Enterprise",
  "ADP NG HCM",
  "WFN Next Generation",
  "ADP Europe"
];

export const customFieldSORs = [
  "ADP",
  "ADP Canada",
  "ADP Europe",
  "ADP NG HCM",
  "WFN Next Generation"
];

export const adpATS = [
  "ADP Recruitment",
  "ADP WFN CA Recruitment Module",
  "ADP Recruit Management"
];

export const ADPSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const dataSource = config["source"];

  // ADP EUROPE currently is the only ADP SOR that allows client side updates of adpKeys
  const handleADPKeysUpdate = (e, dataKey) => {
    let target = e.target;
    let value = target.value;
    let updatedKeys = config["adpKeys"] ?? {};
    updatedKeys[dataKey] = value;
    onChange({ ...config, adpKeys: updatedKeys });
  };

  const handleKeyUpdate = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  const handleOptionSelect = o => {
    handleKeyUpdate(o.dataKey, o.value);
  };

  let customInputHandler = null;
  if (dataSource === "ADP Europe") {
    customInputHandler = handleADPKeysUpdate;
  }

  const isPureATS = adpATS.includes(dataSource);

  let inputOptions = BuildADPInputOptions(config, customInputHandler);
  let showIAT =
    Globals._accountInfo.GetSandboxStatus() || (Globals._wsMgr.fAdminLogin && !isPureATS); //TODO replace when ready

  const showCustomFields =
    (customFieldSORs.includes(config["source"]) &&
      (importType === "import" || importType === "append")) ||
    (importType === "merge" && dataSource === "ADP Detail");

  const adpAdditionalFields = GetADPAdditionalFields(config) || [];
  const additionalFieldOptions = adpAdditionalFields.map(adpHeader => {
    return {
      value: { headerName: adpHeader },
      label: adpHeader
    };
  });
  const onCustomFieldToggle = e => {
    let option = e.value;
    let newHeader = option?.value;
    if (!newHeader) return;
    let customHeaders = config.customheaders ?? [];
    var currentIndex = customHeaders.findIndex(
      sourceItem => JSON.stringify(sourceItem) === JSON.stringify(newHeader)
    );
    if (currentIndex > -1) customHeaders.splice(currentIndex, 1);
    else customHeaders.push(newHeader);
    onChange({ ...config, customheaders: customHeaders });
  };

  const selectedAdditionalFields = config["customheaders"] || [];
  const customFields = config["CustomADPFields"] || [];
  const customFieldOptions = customFields.map(adpHeader => {
    return {
      value: { headerName: adpHeader },
      label: adpHeader
    };
  });

  let canConfigureSOR = importType !== "import" && dataSource !== "ADP Detail";
  let showHeaders = importType !== "import" && !isPureATS;
  if (importType == "merge") {
    showHeaders = false;
  }

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      inputOptions={inputOptions}
      showInputControls
      showAdditionalFields={!adpATS.includes(dataSource)}
      additionalFieldOptions={additionalFieldOptions}
      selectedAdditionalFields={selectedAdditionalFields}
      onAdditionalFieldChange={onCustomFieldToggle}
      showCustomFields={showCustomFields}
      customFieldOptions={customFieldOptions}
      onCustomFieldChange={onCustomFieldToggle}
      selectedCustomFields={selectedAdditionalFields}
      doInputLookup={false}
      showConfiguration={canConfigureSOR}
      showLoadHeaders={showHeaders}
      chartConfig={chartConfig}
      importType={importType}
      ATSType={isPureATS ? enumATSModes.nonConfigurableATS : enumATSModes.notATS}
    >
      {queryAbleADPSORs.indexOf(dataSource) > -1 && importType === "import" && (
        <Select
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-adp-query-preset-select`}
          placeholder={"Insert query..."}
          selectSize={"medium"}
          inputOnly={false}
          label={appstr("Use preset query")}
          options={BuildADPQueryOptions(dataSource, handleOptionSelect)}
        />
      )}
      {showIAT && (
        <Checkbox
          id={"set-adp-iat"}
          size={"medium"}
          label={appstr("IAT endpoint")}
          checked={config.IAT}
          onChange={() => {
            onChange({ ...config, IAT: !config.IAT });
          }}
        />
      )}
    </DataSourceSetupComposite>
  );
};
